import * as angular from "angular";
import { User } from "../../models/user.model";
import { OrganisationUserDataProvider } from "../../data-provider/organisation-user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { Filter } from "../../models/filter.model";
import { Division } from "../../models/division.model";

let DivisionUserListComponent = {
    selector: "vcDivisionUserList",
    templateUrl:
        "/angular/components/division/division-users-list.component.html",
    bindings: {
        division: "=",
        divisionUsers: "=",
    },
    controller: class DivisionUserListController {
        // * bindings for typescript compiler *
        public division?: Division;
        public divisionUsers?: any[];
        // ************************************

        private readonly $scope: any;
        private organisationUserDataProvider: OrganisationUserDataProvider;
        private dialog: DialogUtils;
        private last: number = 0;

        public filter: Filter;
        public columns: object = {
            name: { name: "Name", selected: true },
            email: { name: "Email", selected: true },
            permission: { name: "Permission", selected: true },
        };
        public users: Array<User> = [];
        public loadingData: boolean = true;

        constructor(
            $scope: any,
            OrganisationUserDataProvider: OrganisationUserDataProvider,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.organisationUserDataProvider = OrganisationUserDataProvider;
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.filter = new Filter({
                search: "",
                divisionid: this.division.id,
            });

            this.organisationUserDataProvider
                .getAllUsers(this.filter)
                .then((users: User[] | string) => {
                    if (typeof users === "string") {
                        this.loadingData = false;
                        return;
                    }

                    for (let i = 0; i < this.divisionUsers.length; i++) {
                        this.users.push(
                            users.filter((user: User) => {
                                return this.divisionUsers[i].uid == user.uid;
                            })[0]
                        );
                        this.loadingData = false;
                    }
                });
        }

        openViewUserDialog(user: object, $event: any): void {
            this.dialog.show({
                component: "vc-view-organisation-user",
                targetEvent: $event,
                scope: this.$scope,
                size: "large",
                locals: {
                    selectedUser: user,
                    editable: true,
                },
            });
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("division")
    .component(DivisionUserListComponent.selector, DivisionUserListComponent);
